const INSIDE = 'DROP_POSITIONS/inside'
const BEFORE = 'DROP_POSITIONS/before'
const AFTER = 'DROP_POSITIONS/after'

export const DROP_POSITIONS = {
  INSIDE,
  BEFORE,
  AFTER,
}
